<template>
  <el-row type="flex">
    <el-col :span="24">
      <div class="ra-snippet">
        <div class="ra-snippet--title">
          <div>
            <p>JavaScript</p>
          </div>
          <span
            class="copy"
            title="Copy Code"
            v-clipboard:copy="vanillaSnippet.code"
            v-clipboard:success="onCopy"
          >
            <i class="ra-icon--copy" />
          </span>
        </div>
        <pre>{{ vanillaSnippet.code }}</pre>
      </div>
      <div class="ra-snippet">
        <div class="ra-snippet--title">
          <p>HTML</p>
          <span
            class="copy"
            title="Copy Code"
            v-clipboard:copy="vanillaSnippet.buttons"
            v-clipboard:success="onCopy"
          >
            <i class="ra-icon--clipboard" />
          </span>
        </div>
        <pre>{{ vanillaSnippet.buttons }}</pre>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "AuthXIntegration",
  data() {
    return {};
  },
  computed: {
    app() {
      return this.$store.getters.authx_app;
    },
    vanillaSnippet() {
      if (!this.app.development) {
        return {
          code: "",
          buttons: ""
        };
      }

      const { oauth } = this.app && this.app.development;
      const clientId = oauth.identifier;
      const isSpa = oauth.is_spa;
      const redirectUri = oauth.redirect_uri;

      return {
        code: `
      <script src="https://ajs.radius.africa/authx.js"><${"/script"}>
      <script type="text/javascript">
        function loginHandler (session, message) {
            console.log('logged in ', session, message)
            console.log('Session = ', authx.getSession())
        }

        const authx = AuthX("${clientId}", {
            redirect_uri: "${redirectUri}",
            locale: 'en',
            isSpa: ${isSpa},
            onComplete: loginHandler,
            onError: function (error) {
                alert(error.message)
            }
        })

        function login() {
            authx.initiateSession()
        }

        function signup() {
            authx.initiateSignupSession()
        }

        function logout() {
            authx.logout()
        }
      <${"/script"}>
      `,
        buttons: `
      <button onclick="login()">Login</button>
      <button onclick="signup()">Signup</button>
      <button onclick="logout()">Log Out</button>
      `
      };
    }
  },
  methods: {
    onCopy() {
      this.$message({
        message: `Code copied`,
        type: "success"
      });
    }
  }
};
</script>

<style lang="scss">
.ra-snippet {
  position: relative;
  margin-bottom: 30px;

  &--title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    p {
      font-weight: 500;
      margin-right: 10px;
    }

    div > span {
      font-size: 0.875rem;
      opacity: 0.74;
    }

    .copy {
      cursor: pointer;
      padding: 10px;
      border-radius: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #eee;

      i {
        font-size: 1rem;
        font-weight: 500;
        color: var(--ra-red-primary);
      }
    }
  }

  .copy {
    color: var(--ra-red-primary);
    cursor: pointer;
  }

  pre {
    font-size: 12px;
    background: #eee;
  }
}
</style>
